export { CDNInfoProvider, getCDNInfo } from './cdn-info-provider';

